import { AdoptedPetsCarouselWrapper } from "./AdoptedPetsCarouselWrapper.tsx";
import { AdoptedPetsGridWrapper } from "./AdoptedPetsGridWrapper.tsx";
import { AdoptablePetsFilterableCarouselWrapper } from "./AdoptablePetsFilterableCarousel.tsx";
import { isNullOrEmpty } from "./util.ts";
import { ComponentType } from "react";
import { PAGE_PATHS } from "./config.ts";
import AdoptablePetsGridWrapper from "./AdoptablePetsGridWrapper.tsx";
import AdoptablePetsCarouselWrapper from "./AdoptablePetsCarouselWrapper.tsx";

const TYPE_TO_SPECIES_ID = {
  all: [1, 2, 3, 5],
  dog: 1,
  cat: 2,
  rabbit: 3,
  furry: 5,
  small: [3, 5],
};

type ShowPetsProps = {
  petType: "cat" | "dog" | "small" | "all" | "adopted";
  display?: "carousel" | "grid" | "filterable-carousel";
  title?: string;
  allPetsLink?: string;
};

export function ShowPets({
  petType,
  display,
  title,
  // allPetsLink
}: ShowPetsProps) {
  let ContentComponent: ComponentType<any>;
  const props = {
    params: {
      speciesID: TYPE_TO_SPECIES_ID[petType],
    },
  };

  if (petType === "adopted") {
    switch (display) {
      default:
      case "grid":
        ContentComponent = AdoptedPetsGridWrapper;
        break;
      case "carousel":
        ContentComponent = AdoptedPetsCarouselWrapper;
        break;
    }
  } else {
    switch (display) {
      default:
      case "grid":
        ContentComponent = AdoptablePetsGridWrapper;
        break;
      case "carousel":
        ContentComponent = AdoptablePetsCarouselWrapper;
        break;
      case "filterable-carousel":
        ContentComponent = AdoptablePetsFilterableCarouselWrapper;
        break;
    }
  }

  return (
    <div>
      {!isNullOrEmpty(title) && (
        <h3 className="w-100% text-center text-2xl sm:text-4xl font-bold my-6">
          {title}
          &nbsp;&nbsp;
          <span className="text-sm sm:text-lg">
            <a
              className="text-[#ef3825] hover:color-[#ef3825] no-underline hover:underline"
              href={PAGE_PATHS.FIND_A_PET}
            >
              See All Pets
            </a>
          </span>
        </h3>
      )}
      <ContentComponent {...props} />
    </div>
  );
}
